import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LogService } from '@innovation-os-ng/core/logger';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggingGuard {
  constructor(private readonly logger: LogService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // activate data dog
    this.logger.canLog = true;

    if (route?.data?.loggerConfig && !this.logger?.loggerConfig) {
      this.logger.loggerConfig = route?.data?.loggerConfig;
    }

    this.logger.setupDataDog();

    return true;
  }
}
